import './about.css'
import aboutStyle1 from '../../assets/images/about-style-1-img.png'
import rr from '../../assets/images/rrrrr.png'
import aboutStyleOneShape3 from '../../assets/images/about-style-one-shape-3.png'
import { Link } from 'react-router-dom'

const AboutSection = () => {
    return (
        <div className="about-style-one-area pt-100 pb-100">
            <div className="container">
                <div className="row align-items-center">
                    <div className="col-lg-6">
                        <div className="single-about-img">
                            <div className="about-img-one">
                                <img src={aboutStyle1} alt="images" />
                            </div>
                            <div className="about-shape-1">
                                <img src={rr} alt="images" />
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-6" >
                        <div className="single-about-content">
                            <span>About Us</span>
                            <h2>We Will Make Absolutely Any Place Clean, Neat</h2>
                            <p>Lorem ipsum dolor sit amet consectetur adipisicing elit sed do eiusmod temp incididunt ut labore et dolore magna aliqua sed do eiusmod temp sit amet.</p>
                            <div className="single-about-item">
                                <div className="about-icon bg-color">
                                    <i className="flaticon-favorite"></i>
                                </div>
                                <h3>We Provide Qualified & Expert</h3>
                                <p>Lorem ipsum dolor sit amet consectetur adipisicing elit sed do eiusmod temp incididunt ut labore et dolore magna aliqua.</p>
                            </div>
                            <div className="single-about-item">
                                <div className="about-icon">
                                    <i className="flaticon-wrench"></i>
                                </div>
                                <h3>Modern Tools & Technology Use</h3>
                                <p>Lorem ipsum dolor sit amet consectetur adipisicing elit sed do eiusmod temp incididunt ut labore et dolore magna aliqua.</p>
                            </div>
                            <Link href="/about" className="default-btn">Learn More</Link>
                        </div>
                    </div>
                </div>
            </div>
            <div className="about-style-shape-1">
                <img src={aboutStyleOneShape3} alt="images" />
            </div>
        </div>
    )
}

export default AboutSection